import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ContentProvider } from './context/ContentContext';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ContentProvider>
      <App />
    </ContentProvider>
  </React.StrictMode>
);
